import { useEffect,useMemo, useState } from 'react';

import OpenStepAccordeonIcon from '@/shared-components/icons/components/forms/OpenStepAccordeonIcon';
import InfoIconArtwork from '@/shared-components/icons/components/public/InfoIconArtwork';
import PublicSuccessCheck from '@/shared-components/icons/components/public/PublicSuccessCheck';
import Heading from '@/shared-components/text/components/Heading';
import Text from '@/shared-components/text/components/Text';

import './styles/StepAccordeon.css';

export default function StepAccordeon({ lastCompletedStep, step, header, previewMode, editMode, activeClassName="step-accordeon__content-active-default", formError, elements, children }) {
  const [active, setActive] = useState(editMode === true || previewMode === true || lastCompletedStep + 1 === step || lastCompletedStep >= 3); 
  const disabled = useMemo(()=>{ 
    if(previewMode === true || editMode===true) return false;
    return step > (lastCompletedStep + 1);
  }, [lastCompletedStep]);

  const [isInfoIconOpen, setIsInfoIconOpen] = useState(false);

  useEffect(()=>{
    setActive(editMode === true || previewMode === true || lastCompletedStep + 1 === step || lastCompletedStep >= 3);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [lastCompletedStep]);

  useEffect(()=>{
    if(elements && elements.includes(formError?.element)) setActive(true);
  }, [formError]);

  const shippingInfoHeader = {
    name: 'Shipping',
    description: `The Gallery is responsible for shipping original artworks, while Suarte produces and distributes Limited Editions. Upon receiving a new order, the Gallery has seven days to dispatch the artwork and update the order panel with the courier and tracking information.\n\nWhen uploading artworks, the Gallery must select a national and international shipping cost. They can choose to either cover the shipping costs themselves or pass them on to the end customer.\n\nAlways ensure that the artwork is professionally packaged and adequately protected for its journey to its new home`
  };

  return (
    <>
      <div className={`step-accordeon__container${active ? " active" : ""}${disabled ? " disabled" : ""} ${header === "Shipping" ? "no-border" : ""}`}>
        <div className={`step-accordeon__step-header${header==="About" ? " no-padding" : ""}`} onClick={()=>{if(!disabled) setActive(!active);}}>
          <div className="step-accordeon-step-header__text-container">
            <Text className="step-accordeon-step-header__text" small paragraph>Step {step} of 3</Text>
            <h2 className="step-accordeon-step-header__heading">
              <Heading large>{header}</Heading>
              {step === 3 && (
                <InfoIconArtwork
                  className="step-accordeon-step-header__info-icon non-selectable-info-icon"
                  onClick={(status) => setIsInfoIconOpen(status)}
                  open={isInfoIconOpen}
                  header={shippingInfoHeader.name}
                  description={shippingInfoHeader.description}
                />
              )}
            </h2>
          </div>

          {(editMode===false && (previewMode === true || step <= lastCompletedStep)) && (<PublicSuccessCheck className="step-accordeon-step-header__completed-icon"/>)}
          <OpenStepAccordeonIcon className="step-accordeon-step-header__icon"/>
        </div>

        <div className={`step-accordeon__content ${active ? activeClassName : ""}`}>
          {children}
        </div>
      </div>
    </>
  );
}
